// form.js (refactored, no jQuery)
import axios from 'axios'

export default {
  props: ['id'],
  data() {
    return {
      validation: {}, // { errors?: Record<string,string[]>, data?: Record<string,string[]> }
      pending: false,
    }
  },
  computed: {
    isNew() {
      // treat undefined, null, empty string, or literal 'undefined' as new
      return this.id == null || this.id === '' || this.id === 'undefined'
    },
  },
  methods: {
    async fetchData() {
      if (!this.isNew) {
        // implement your fetch logic here if needed
      }
    },

    onModelChanged() {},

    // helper to pick the bag we actually have
    _bag() {
      if (this.validation && typeof this.validation === 'object') {
        if (
          this.validation.errors &&
          typeof this.validation.errors === 'object'
        ) {
          return this.validation.errors
        }
        if (this.validation.data && typeof this.validation.data === 'object') {
          return this.validation.data
        }
      }
      return null
    },

    feedback(name) {
      const bag = this._bag()
      if (!bag) return
      const msgs = bag[name]
      return Array.isArray(msgs) && msgs.length ? msgs[0] : undefined
    },

    state(name) {
      const bag = this._bag()
      if (!bag) return null
      return Object.prototype.hasOwnProperty.call(bag, name) ? 'invalid' : null
    },

    async onSubmit(event) {
      this.pending = true

      const action = this.isNew
        ? this.createPath
        : [this.updatePath, this.id].filter(Boolean).join('/')

      // Convert your model to FormData (assuming you have this helper)
      const formData = this.$app.objectToFormData(this.model)

      if (!this.isNew) {
        formData.append('_method', 'PUT')
      }

      try {
        const { data } = await axios.post(action, formData)

        this.pending = false

        if (this.isModal) {
          this.$emit('context-changed')
        }

        // Navigate back to list if configured and no continuePath
        if (this.listPath && !this.continuePath) {
          window.location.replace(this.listPath)
        }

        // Continue flow
        if (this.continuePath && data && data.id) {
          window.location.replace(
            `${this.continuePath}/${data.id}/submit-review`,
          )
        }

        // If modal, refresh and close
        if (this.isModal) {
          this.refreshData?.()
          this.$emit('close')
        }
      } catch (e) {
        this.pending = false

        // Validation errors
        if (e?.response?.status === 422) {
          this.validation = e.response.data || {}

          // Scroll to first invalid field
          const options = {
            container: 'body',
            easing: 'ease-in-out',
            offset: -150,
            force: true,
            cancelable: true,
            onStart: () => {},
            onDone: () => {},
            onCancel: () => {},
            x: false,
            y: true,
          }

          this.$nextTick(() => {
            const firstInvalid = document.querySelector('.invalid')
            if (firstInvalid) {
              // If you use vue-scrollto plugin:
              if (typeof this.$scrollTo === 'function') {
                this.$scrollTo(firstInvalid, 400, options)
              } else {
                // native smooth scroll fallback
                const top =
                  firstInvalid.getBoundingClientRect().top +
                  window.pageYOffset +
                  (options.offset || 0)
                window.scrollTo({ top, behavior: 'smooth' })
              }
            }
          })

          return
        }

        // Other errors
        this.$app.error?.(e)
      }
    },

    modalClose() {
      this.$emit('close')
    },
  },

  created() {
    this.fetchData()
  },
}
